import { render } from "./LeftRightTree.vue?vue&type=template&id=52956cb0&scoped=true"
import script from "./LeftRightTree.vue?vue&type=script&lang=js"
export * from "./LeftRightTree.vue?vue&type=script&lang=js"

import "./LeftRightTree.vue?vue&type=style&index=0&id=52956cb0&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CodeV4\\FCP-Web-V4\\leanloop-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52956cb0"]])

export default __exports__